export class RegistrationRequestFull {
    public ID: number;
    public HashCode: string;
    public Board: string;
    public Medium: string;
    public OldBoard: string;
    public OldMedium: string;
    public InstituteTypeID: string;
    public OldInstituteTypeID: string;
    public SchoolMailID: string;
    public Section: string;
    public OldSection: string;
    public DesignationID: number;
    public PrinDesignation: string;
    public PrincipalName: string = "";
    public PrincipalMobileNo: string = "";
    public PrincipalMailID: string = "";
    public PrincipalDetail: Array<any> = [];
    public OldPrincipalDetail: Array<any> = [];
    public AuthorizedPerson: string;
    public Designation: string;
    public MobileNo: string;
    public WhatsAppNo: string;
    public playGroup: number;
    public nursery: number;
    public jrkg: number;
    public srkg: number;
    public std1: number;
    public std2: number;
    public std3: number;
    public std4: number;
    public std5: number;
    public std6: number;
    public std7: number;
    public std8: number;
    public std9: number;
    public std10: number;
    public std11sci: number;
    public std12sci: number;
    public std11com: number;
    public std12com: number;
    public std11arts: number;
    public std12arts: number;
    public StandardDetails: Array<any> = [];
    public OldStandardDetails: Array<any> = [];
    public OwnerName: string = "";
    public OwnerMobileNo: string = "";
    public OwnerMailID: string = "";
    public OwnerDetail: Array<any> = [];
    public OldOwnerDetail: Array<any> = [];
    public TrusteeName: string = "";
    public TrusteeAddress: string= "";
    public TrusteeMobileNo: string= "";
    public TrusteeMailID: string= "";
    public TrusteeDetail: Array<any> = [];
    public OldTrusteeDetail: Array<any> = [];
    public LandArea: number;
    public LandConstruction: number;
    public PendingSalaryIncrementAmount: number;
    public PendingSalaryIncrementDescription: string = "";
    public DepreciationAmount: number;
    public DepreciationDescription: string = "";
    public Remarks: string = "";
    public RequestStatus: number;
    public YearID: number;
    public InfrastructureID: number;
    public NoOfInfrastructure: number;
    public InfrastructureSize: number;
    public InfrastructureDetail: Array<any> = [];
    public OldInfrastructureDetail: Array<any> = [];
    public EmployeeTypeID: number;
    public NoOfPermanentEmployee: number;
    public NoOfAdhocEmployee: number;
    public TotalPermanentSalary: number;
    public TotalAdhocSalary: number;
    public EmployeeDetail: Array<any> = [];
    public OldEmployeeDetail: Array<any> = [];
    public ClassroomDetail: Array<any> = [];
    public OldClassroomDetail: Array<any> = [];
    public NoOfClassroom: number;
    public QualificationID: number;
    public NoofEmployee: number;
    public EmployeeQualificationDetail: Array<any> = [];
    public OldEmployeeQualificationDetail: Array<any> = [];
    public OldAuthorizedPerson : string;
    public OldDesignation : string;
    public OldMobileNo : string;
    public OldNoOfClassroom :number;
    public OldWhatsAppNo : string;
    public OldPendingSalaryIncrementAmount : number;
    public OldPendingSalaryIncrementDescription : string = "";
    public OldDepreciationAmount: number;
    public OldDepreciationDescription : string = "";
    public OldRemarks : string = "";
    public OldLandArea: number;
    public OldLandConstruction : number;
}